import { createFileRoute, redirect } from '@tanstack/react-router';

// The bare section URL lands on the first view.
export const Route = createFileRoute('/operating-costs/')({
  beforeLoad: () => {
    throw redirect({ to: '/operating-costs/overheads' });
  },
});
